import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "InscripcionPagoTesoreriaPage",
    data() {
        let ss = new MainService();
        return {
            msg: "InscripcionPagoTesoreriaPage",
            ss: ss,
            ajax: {
                "url": ss.indexInscripcionPagoTesoreria(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'PagoTesoreriaH', name: 'PagoTesoreriaH', title: 'Pago Tesoreria H' },
                { data: 'Nombres', name: 'Nombres', title: 'Nombres' },
                { data: 'ApellidoPaterno', name: 'ApellidoPaterno', title: 'ApellidoPaterno' },
                { data: 'ApellidoMaterno', name: 'ApellidoMaterno', title: 'ApellidoMaterno' },
                { data: 'MontoTotal', name: 'MontoTotal', title: 'MontoTotal' },
                { data: 'Descuento', name: 'Descuento', title: 'Descuento' },
                { data: 'Pagable', name: 'Pagable', title: 'Pagable' },
                { data: 'Saldo', name: 'Saldo', title: 'Saldo' },
                { data: 'Cantidad', name: 'Cantidad', title: 'Cantidad' },
                { data: 'Pagado', name: 'Pagado', title: 'Pagado' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            inscripcionpagotesorerias: [],
            inscripcionpagotesoreria: {},
            nivelesacademicos: [],
            pagostesoreria: [],
            inscripciones: [],
            isLoading: false,
            errorBag: {}
        };
    },
    methods: {
        //////////get nivel academico ////////////////////
        getNivelAcademico() {
            this.ss.listNivelAcademico().then(
                (result) => {
                    let response = result.data;
                    this.nivelesacademicos = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },
        //////////get pagos tesoreria ////////////////////
        getPagosTesoreria() {
            this.ss.listPagoTesoreria().then(
                (result) => {
                    let response = result.data;
                    this.pagostesoreria = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },
        //////////get Inscripcion////////////////////
        getInscripcion() {
            this.ss.listInscripcion().then(
                (result) => {
                    let response = result.data;
                    this.inscripciones = response.data;
                }
            ).catch(error => {
                console.log(error);
            });
        },
        newInscripcionPagoTesoreria() {
            this.inscripcionpagotesoreria = {};
            this.$refs['frm-inscripcionpagotesoreria'].show();
        },
        showInscripcionPagoTesoreria(id) {
            this.isLoading=true;
            this.ss.showInscripcionPagoTesoreria(id).then(
                (result) => {
                    let response = result.data;
                    this.inscripcionpagotesoreria = response.data;
                    this.$refs['view-inscripcionpagotesoreria'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editInscripcionPagoTesoreria() {
            this.$refs['frm-inscripcionpagotesoreria'].show();
            this.$refs['view-inscripcionpagotesoreria'].hide();
        },
        cancelInscripcionPagoTesoreria() {
            if (this.inscripcionpagotesoreria.id) {
                this.$refs['view-inscripcionpagotesoreria'].show();
            }
            this.$refs['frm-inscripcionpagotesoreria'].hide();
        },
        saveInscripcionPagoTesoreria() {
            this.ss.storeInscripcionPagoTesoreria(this.inscripcionpagotesoreria).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-inscripcionpagotesoreria'].hide();
                    this.$refs['datatable-inscripcionpagotesoreria'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteInscripcionPagoTesoreria() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
                showCancelButton: true,
                cancelButtonColor: '#d33',
            })
                .then((willDelete) => {
                    if (willDelete.isConfirmed) {
                        this.ss.destroyInscripcionPagoTesoreria(this.inscripcionpagotesoreria)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-inscripcionpagotesoreria'].hide();
                                this.$refs['datatable-inscripcionpagotesoreria'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-InscripcionPagoTesoreria').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showInscripcionPagoTesoreria(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        if (!persona) {
          this.$router.push('/Login');
        }else{
            //this.getNivelAcademico();
            this.getPagosTesoreria();
            this.getInscripcion();
        }
    }
};
